"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _require = require("../../utils"),
    reflectURLAttribute = _require.reflectURLAttribute;

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var idlUtils = require("../generated/utils");

var _require2 = require("../helpers/stylesheets"),
    fetchStylesheet = _require2.fetchStylesheet;

var _require3 = require("../helpers/document-base-url"),
    parseURLToResultingURLRecord = _require3.parseURLToResultingURLRecord;

var whatwgURL = require("whatwg-url"); // Important reading: "appropriate times to obtain the resource" in
// https://html.spec.whatwg.org/multipage/semantics.html#link-type-stylesheet


var HTMLLinkElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLLinkElementImpl, _HTMLElementImpl);

  var _super = _createSuper(HTMLLinkElementImpl);

  function HTMLLinkElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLLinkElementImpl);

    _this = _super.call(this, args, privateData);
    _this.sheet = null;
    return _this;
  }

  _createClass(HTMLLinkElementImpl, [{
    key: "_attach",
    value: function _attach() {
      _get(_getPrototypeOf(HTMLLinkElementImpl.prototype), "_attach", this).call(this);

      if (isExternalResourceLink(this)) {
        obtainTheResource(this);
      }
    }
  }, {
    key: "_attrModified",
    value: function _attrModified(name, value, oldValue) {
      _get(_getPrototypeOf(HTMLLinkElementImpl.prototype), "_attrModified", this).call(this, name, value, oldValue);

      if (name === "href" && this._attached && isExternalResourceLink(this)) {
        obtainTheResource(this);
      }
    }
  }, {
    key: "_accept",
    get: function get() {
      return "text/css,*/*;q=0.1";
    }
  }, {
    key: "href",
    get: function get() {
      return reflectURLAttribute(this, "href");
    },
    set: function set(value) {
      this.setAttribute("href", value);
    }
  }]);

  return HTMLLinkElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLLinkElementImpl
};

function obtainTheResource(el) {
  var href = el.getAttribute("href");

  if (href === null || href === "") {
    return;
  }

  var url = parseURLToResultingURLRecord(href, el._ownerDocument);

  if (url === null) {
    return;
  }

  var serialized = whatwgURL.serializeURL(url);
  fetchStylesheet(el, serialized);
}

function isExternalResourceLink(el) {
  // for our purposes, only stylesheets can be external resource links
  var wrapper = idlUtils.wrapperForImpl(el);

  if (!/(?:[ \t\n\r\f]|^)stylesheet(?:[ \t\n\r\f]|$)/i.test(wrapper.rel)) {
    // rel is a space-separated list of tokens, and the original rel types
    // are case-insensitive.
    return false;
  }

  return Boolean(el.href);
}